import React from 'react';
import LocationTemplate from './LocationTemplate';

const TurkeyPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Turkey"
      stateName="North Carolina"
      countyName="Sampson"
      zipCodes={["28393"]}
      latitude={35.004}
      longitude={-78.1843}
      population={292}
      historicalFact="Small town in Sampson County known for turkey production."
      nearbyTowns={[
        "Clinton, NC",
        "Warsaw, NC",
        "Rose Hill, NC",
        "Calypso, NC",
        "Garland, NC",
        "Newton Grove, NC",
        "Roseboro, NC",
        "Salemburg, NC"
      ]}
    />
  );
};

export default TurkeyPage;